import { NumberInput, type NumberInputProps } from '@mantine/core';
import { FIELD_STYLES } from './InputWithLabel';

// The shared field styles pin the border, which would leave a field reading grey while the
// message under it says otherwise, so a field in error paints its own.
const ERROR_STYLES = {
  ...FIELD_STYLES,
  input: { ...FIELD_STYLES.input, border: '1px solid var(--mantine-color-error)' },
};

export function NumberInputWithLabel({ ...props }: NumberInputProps) {
  return <NumberInput {...props} styles={props.error ? ERROR_STYLES : FIELD_STYLES} />;
}
